module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"encodingError":"Message contains unsupported characters","lengthError":"Message exceeds {maxCharacterCount}-character limit"}}')
  delete Component.options._Ctor
}
